var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-143 145 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329,145h-432c-22.1,0-40,17.9-40,40v432c0,22.1,17.9,40,40,40h432c22.1,0,40-17.9,40-40V185C369,162.9,351.1,145,329,145z  M339,617c0,5.5-4.5,10-10,10h-432c-5.5,0-10-4.5-10-10V185c0-5.5,4.5-10,10-10h432c5.5,0,10,4.5,10,10V617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5,296.4c-35.6-1.1-59.7,18.8-72.3,59.7c6.5-2.7,12.8-4,18.9-4c13,0,18.7,7.3,17.2,21.8c-0.8,8.9-6.5,21.7-17.2,38.5 s-18.8,25.2-24.1,25.2c-6.9,0-13.2-13-18.9-39c-1.9-7.6-5.4-27.1-10.3-58.5c-4.6-29-16.8-42.6-36.7-40.7c-8.5,0.8-21.1,8.4-37.9,23 c-12.3,11-24.7,22.1-37.3,33.2l12,15.5C8.4,363,15.1,359,17,359c8.8,0,17,13.7,24.7,41.3c6.9,25.2,13.8,50.4,20.7,75.7 c10.3,27.6,22.9,41.3,37.8,41.3c24.1,0,53.6-22.5,88.4-67.7c33.7-43.2,51.1-77.2,52.2-102.1C242.4,314.3,230,297.3,203.5,296.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.2b0352c53d191a0be8725bdc36fb405e.svg";
export { ForwardRef as ReactComponent };